<template>
  <div
    class="relative z-50"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div class="fixed inset-0 bg-charcoal-100/75 transition-opacity" />

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full justify-center">
        <div class="relative m-5 w-full rounded-lg bg-white p-10 md:m-20 xl:w-3/6">
          <CloseIcon
            class="absolute right-[30px] top-[30px] size-5 cursor-pointer *:stroke-charcoal-100"
            aria-hidden="true"
            @click="props.toggle()"
          />

          <!-- Registration Form -->
          <div
            data-blackbaud-registration-form
            :data-blackbaud-registration-form-id="props.form"
            data-blackbaud-registration-form-envid="p-2EYQBLYezEiFbHY_h8lblw"
            data-blackbaud-registration-form-zone="eur"
            data-blackbaud-registration-form-header-height="0"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CloseIcon from "~/assets/svgs/cross.svg";

const props = defineProps<{
  toggle: () => void;
  form: string | null;
}>();

useHead({
  // Script from Blackbaud System
  script: [
    {
      "src": "https://sky.blackbaudcdn.net/static/reg-form-loader/5/main.js",
      "data-categories": "essential",
    }],
});
</script>
